import { Controller } from "../../ts/controller";
import { Logger } from "../../ts/utils/logger";

const materialIconAdd = `
    <svg xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px">
        <path style="fill: var(--primary-color);"
            d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
    </svg>`;

const materialIconRemove = `
    <svg xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px">
        <path style="fill: var(--primary-color);"
            d="M200-440v-80h560v80H200Z" />
    </svg>`;

class HomePageSection {
    /** The DOM ID of the section */
    id: string;
    /** Whether the section is collapsed by default */
    collapsed: boolean;

    constructor({
        id,
        collapsed = false,
    }: {
        id: string,
        collapsed: boolean
    }) {
        this.id = id;
        this.collapsed = collapsed;
    }
}

export class HomePageController extends Controller {
    sections: HomePageSection[] = [
        new HomePageSection({
            id: "home-page-recent-comments-highlight",
            collapsed: false,
        }),
    ];

    constructor() {
        super({
            logLabel: "HomePageController",
        });
    }

    public initialize(): void {
        this._initializeCollapseClickListeners();
        this._setState();
        Logger.info(this.logLabel, "Initialized");
    }

    private _initializeCollapseClickListeners(): void {
        this.sections.forEach((section) => {
            const button = document.querySelector(
                `#${section.id} .home-page-highlight-collapse-button`
            ) as HTMLButtonElement;
            if (button) {
                button.addEventListener("click", () => {
                    section.collapsed = !section.collapsed;
                    this._setState();
                });
            }
        });
    }

    private _setState(): void {
        this.sections.forEach((section) => {
            const sectionElement = document.getElementById(section.id) as HTMLElement;
            const button = sectionElement.querySelector(
                ".home-page-highlight-collapse-button"
            ) as HTMLElement;
            const content = sectionElement.querySelector(
                ".home-page-highlight-content"
            ) as HTMLElement;

            if (section.collapsed) {
                content.style.display = "none";
                button.innerHTML = materialIconAdd;
            } else {
                content.style.display = "block";
                button.innerHTML = materialIconRemove;
            }
        });
    }
}
